import { render } from "./product.vue?vue&type=template&id=44c93384&scoped=true&bindings={\"topImg\":\"data\",\"current\":\"data\",\"content\":\"data\"}"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=44c93384&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-44c93384"

export default script